import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { LancamentosDeCaixa } from '../../../models/lancamentosDeCaixa.model';
import { Router } from '@angular/router';
import { LancamentosDeCaixaService } from '../../../services/lancamentos-de-caixa.service';
import { finalize } from 'rxjs';
import { SpinnerService } from '../../../services/spinner.service';
import { ToastService } from '../../../services/toast.service';
import { SeveridadeToast } from '../../../models/enums/severidade-toast.enum';
import { LancamentoCaixaEnum } from '../../../models/enums/lancamentoDeCaixaEnum';
import { ConfirmationService } from 'primeng/api';
import { Icones } from '../../../shared/variaveisDeRotas';
import { JwtHelper } from '../../../helpers/jwtDecode.helper';
import { retornaDescricao } from '../../../shared/mock/descricao';

@Component({
  selector: 'app-listar-lancamento-caixa',
  templateUrl: './listar-lancamento-caixa.component.html',
  styleUrl: './listar-lancamento-caixa.component.scss',
  providers: [ConfirmationService]
})
export class ListarLancamentoCaixaComponent implements OnInit {
  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();

  @Output() tituloDescricao = new EventEmitter<string>();
  @Output() textoDescricao = new EventEmitter<string>();
  @Output() mostrarDescricao = new EventEmitter<boolean>();

  @ViewChild('dt') dt: Table | undefined;
  iconesParaHtml: any;

  lancamentosDeCaixa: LancamentosDeCaixa[] = [];
  loading: boolean = false;
  userId: string;
  selectedLancamentoCaixa: LancamentosDeCaixa | null = null;
  detailsDialogVisible: boolean = false;

  constructor(
    private router: Router,
    private lancamentoDeCaixa: LancamentosDeCaixaService,
    private spinnerService: SpinnerService,
    private toastService: ToastService,
    private confirmationService: ConfirmationService,
    private jwtHelper: JwtHelper,) {
    this.userId = this.jwtHelper.getUserIdFromToken();
  }

  ngOnInit(): void {
    this.tituloChange.emit('Lista de Lançamentos de Caixa');
    this.iconeChange.emit(Icones.listaTopicoAmarelo);
    this.tituloDescricao.emit(retornaDescricao('lancamentoCaixa').titulo);
    this.textoDescricao.emit(retornaDescricao('lancamentoCaixa').texto);
    this.mostrarDescricao.emit(true)

    this.loadlancamentosDeCaixa()
  }

  ngOnDestroy(): void {
    this.mostrarDescricao.emit(false);
  }


  async loadlancamentosDeCaixa(): Promise<void> {
    this.spinnerService.show('Carregando lançamentos de caixa...');
    
    this.lancamentoDeCaixa
      .listaLancamentosDeCaixa(this.userId)
      .pipe(finalize(() => this.spinnerService.hide()))
      .subscribe({
        next: (data) => {
          this.lancamentosDeCaixa = data || [];
          this.spinnerService.hide();
        },
        error: (error) => {
          this.toastService.setMensagemToast(
            `Erro ao carregar Lançamentos caixa: ${error.error?.message || error.message}`,
            SeveridadeToast.Error
          );
          this.spinnerService.hide();
        }
      });
  }

  retornaLancamentoCaixaTipoEnum(tipo: number): string {
    switch (tipo) {
      case LancamentoCaixaEnum.Pagamento:
        return 'Pagamento';
      case LancamentoCaixaEnum.Recebimento:
        return 'Recebimento';
      default:
        return 'Desconhecido';
    }
  }

  detalhesLancamentoCaixa(lancamentoCaixa: LancamentosDeCaixa): void {
    this.selectedLancamentoCaixa = lancamentoCaixa;
    this.detailsDialogVisible = true;
  }

  editarLancamentoCaixa(lancamentoCaixa: LancamentosDeCaixa): void {
    this.router.navigate(['editar-lancamento-caixa', lancamentoCaixa.Id]);
  }

  excluirLancamentoCaixa(lancamentoCaixaId: number): void {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja deletar esse lançamento?',
      header: 'Confirmar Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.spinnerService.show('Excluindo lançamento caixa...');
        this.lancamentoDeCaixa.deleteLancamentoCaixa(lancamentoCaixaId).subscribe({
          next: () => {
            this.toastService.setMensagemToast('Lançamento caixa excluído com sucesso.', SeveridadeToast.Success);
            this.loadlancamentosDeCaixa()
            this.spinnerService.hide();
          },
          error: (e) => {
            console.error('Erro ao excluir lançamento caixa:', e);
            this.toastService.setMensagemToast(`Erro ao excluir lançamento caixa: ${e.error?.message || 'Erro desconhecido'}`, SeveridadeToast.Error);
            this.spinnerService.hide();
          }
        });
      },
    });
  }

  transformaData(data: number): string {
    const dataString = data.toString();

    const ano = dataString.substring(0, 4);
    const mes = dataString.substring(4, 6);
    const dia = dataString.substring(6, 8);

    const dataFormatada = `${dia}/${mes}/${ano}`;

    return dataFormatada;
  }

  applyFilterGlobal(filterValue: string) {
    this.dt?.filterGlobal(filterValue, 'contains');
  }

  navigateToAddLancamento() {
    this.router.navigate(['/adicionar-lancamento-caixa']);
  }
}
